import type { Phrases } from '../common/Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span } from '../../../components/Element';
import { TextArea } from '../../../components/react-hook-form/TextArea';
import {
	SERVICES_FIELD_NAME,
	FIELD_VALUE_ANALYZED,
} from './constants';


export const AnalyzedResultTextArea = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const { setScrollRef } = useFormContext();

	const label = phrases['notificationForm.services.analyzedResultField.label'];

	const scrollRef = useRef();

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: SERVICES_FIELD_NAME.ANALYZED_RESULT, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<TextArea
			errorSummaryLabel={label}
			label={<Span
				className='font-semibold text-xl'
				elementRef={scrollRef}
			>{label}</Span>}
			name={SERVICES_FIELD_NAME.ANALYZED_RESULT}
			showIf={
				({watch}) => watch({ name: SERVICES_FIELD_NAME.ANALYZED }) === FIELD_VALUE_ANALYZED.YES
			}
		/>
	);
};
